import type { GameInitialSettings } from "../boot/settings/GameInitialSettingsTypes";

/**
 * Whether the player can use autospin at all: the operator's switch is on AND the backend sent the
 * counts to offer. With no counts there is nothing to pick, so there is no toggle, no picker and no
 * autospin section on the info page (user, 2026-09-23).
 *
 * One rule, read by the bar and by the info page. Until 2026-09-23 they disagreed on an omitted list:
 * the picker fell back to frontend default counts while the info page printed "Available counts: ."
 * (review finding 21).
 */
export function isAutospinAvailable(settings: Pick<GameInitialSettings, "autospinEnabled" | "autospinPresets">): boolean {
  return settings.autospinEnabled !== false && (settings.autospinPresets?.length ?? 0) > 0;
}
